<template>
  <div style="width:100%; padding-top: 60px">
    <div style="position: fixed;background-color: white;top: 0px;z-index: 999;width: 100%;">
      <div style="text-align:center">
        <van-button type="info" size="small" style="margin-left: 3%;width: 15%;" @click="goBack">返回</van-button>
        <screenButton class="screenButton"></screenButton>
      </div>
    </div>

    <b-table class="bgc-dark" head-variant="dark" responsive bordered
             :items="items" :fields="fields1" foot-clone>
      <template v-slot:head()="scope">
        <div class="text-nowrap" style="text-align:center; vertical-align: middle;">
          {{ scope.label }}
        </div>
      </template>
      <template v-slot:cell(index)="data">
        {{ data.index + 1 }}
      </template>
      <!--      <template v-slot:cell(contractorName)="data">-->
      <!--        <div style="color: #4caedc" @click="showDetail(data.item.contractorName)">{{ data.item.contractorName }}</div>-->
      <!--      </template>-->
      <!--      <template v-slot:cell(joinDate)="data">-->
      <!--        {{moment(data.item.joinDate).format("YYYY-MM-DD")}}-->
      <!--      </template>-->
      <!--      <template v-slot:cell(leaveDate)="data">-->
      <!--        {{-->
      <!--          (data.item.leaveDate === '' || data.item.leaveDate === undefined) ? '-' : moment(data.item.leaveDate).format("YYYY-MM-DD")-->
      <!--        }}-->
      <!--      </template>-->
      <template v-slot:cell(saleGrossWeight)="data">
        {{ Number(data.item.saleGrossWeight).toFixed(2) }}
      </template>
      <template v-slot:cell(agreePackWeight)="data">
        {{ Number(data.item.agreePackWeight).toFixed(2) }}
      </template>
      <template v-slot:cell(salePackageTotalWeight)="data">
        {{ Number(data.item.salePackageTotalWeight).toFixed(2) }}
      </template>
      <template v-slot:cell(saleNetWeight)="data">
        {{ Number(data.item.saleNetWeight).toFixed(2) }}
      </template>
      <template v-slot:cell(salePriceOrigin)="data">
        {{ Number(data.item.salePriceOrigin).toFixed(2) }}
      </template>
      <template v-slot:cell(saleAmountOrigin)="data">
        {{ Number(data.item.saleAmountOrigin).toFixed(2) }}
      </template>
      <template v-slot:cell(exchangeRate)="data">
        {{ Number(data.item.exchangeRate).toFixed(6) }}
      </template>
      <template v-slot:cell(salePriceHome)="data">
        {{ Number(data.item.salePriceHome).toFixed(2) }}
      </template>
      <template v-slot:cell(saleAmountHome)="data">
        {{ Number(data.item.saleAmountHome).toFixed(2) }}
      </template>
<!--      <template v-slot:cell(remark)="data">-->
<!--        <div style="color: #4caedc" @click="showDetail(data.item.remark)">{{ data.item.remark }}</div>-->
<!--      </template>-->

      <template v-slot:table-colgroup="scope">
        <col
            v-for="field in scope.fields"
            :key="field.key"
            :style="{ width: field.width }"
        >
      </template>
      <template v-slot:foot()="scope">
        <div class="text-nowrap" :style="{textAlign:'center'}">-</div>
      </template>
      <template v-slot:foot(saleDate)="data">
        <div class="text-nowrap" :style="{textAlign:'center',fontSize:'12px'}">小计</div>
      </template>
      <template v-slot:foot(saleGrossWeight)="data">
        <div class="text-nowrap" :style="{textAlign:'center',fontSize:'12px'}">{{ sumNum(items, 'saleGrossWeight') }}</div>
      </template>
      <template v-slot:foot(salePackageCount)="data">
        <div class="text-nowrap" :style="{textAlign:'center',fontSize:'12px'}">{{ sumNum(items, 'salePackageCount', 0) }}</div>
      </template>
      <template v-slot:foot(salePackageTotalWeight)="data">
        <div class="text-nowrap" :style="{textAlign:'center',fontSize:'12px'}">{{ sumNum(items, 'salePackageTotalWeight') }}</div>
      </template>
      <template v-slot:foot(saleNetWeight)="data">
        <div class="text-nowrap" :style="{textAlign:'center',fontSize:'12px'}">{{ sumNum(items, 'saleNetWeight') }}</div>
      </template>
      <template v-slot:foot(saleAmountHome)="data">
        <div class="text-nowrap" :style="{textAlign:'center',fontSize:'12px'}">{{ sumNum(items, 'saleAmountHome') }}</div>
      </template>
    </b-table>
  </div>
</template>

<script>
import {Decimal} from "decimal.js";
import moment from "moment";

export default {
  name: "ItsSalesDomesticDetail",
  data() {
    return {
      fields1: [
        {key: 'saleDate', label: '销售日期', width: '120px'},
        {key: 'brandName',  label: '产品品牌', width: '120px'},
        {key: 'varietyLevelLabel',  label: '产品等级', width: '120px'},
        {key: 'packModelLabel', label: '单件规格', width: '120px'},
        {key: 'packName', label: '包装材料名称', width: '120px'},
        {key: 'agreePackWeight', label: '约定包装材料重量（斤/件）', width: '160px'},
        {key: 'saleGrossWeight', label: '含筐总重（斤）', width: '120px'},
        {key: 'salePackageCount', label: '销售件数', width: '120px'},
        {key: 'salePackageTotalWeight', label: '包装材料总重（斤）', width: '120px'},
        {key: 'saleNetWeight', label: '销售净重（斤）', width: '120px'},
        {key: 'salePriceOrigin', label: '销售单价', width: '120px'},
        {key: 'currencyName', label: '币种', width: '120px'},
        {key: 'saleAmountOrigin', label: '原币金额', width: '120px'},
        {key: 'exchangeRate', label: '汇率', width: '120px'},
        {key: 'salePriceHome', label: '美元销售单价（美元/斤）', width: '120px'},
        {key: 'saleAmountHome', label: '美元金额（美元）', width: '120px'},
      ],
      items: [],
      unitCategory: '',
    }
  },
  created() {
    this.items = JSON.parse(this.$route.query.data)
  },
  methods: {
    init() {

    },
    goBack() {
      this.$router.back()
    },
    showDetail(content) {
      if (content === '') {
        return
      }
      this.$dialog.alert({
        message: content,
        confirmButtonColor: '#409EFF'
      })
    },
    rowClass() {
      return 'row-center'
    },
    // 合计计算
    sumNum(arr, key, n = 2) {
      if (!Array.isArray(arr) || typeof key !== 'string') {
        return 0;
      }
      return arr.reduce((total, item) => {
        if (key in item) {
          const value = Number(item[key]);
          return isNaN(value) ? total : new Decimal(total).add(new Decimal(value)).toFixed(n, Decimal.ROUND_HALF_UP);
        }
        return total;
      }, 0);
    },
  }
}
</script>

<style scoped>
.row-center {
  display: flex;
  justify-content: center;
}
</style>